import Api from '@/api';
import i18n from '@/i18n.js';

const state = {
    filters: []
};

const mutations = {
    SET_FILTERS(state, filters) {
        state.filters = filters
    }
};

const getters = {
    FILTERS(state) {
        return state.filters
    }
};

const actions = {
    async FETCH_FILTERS({ commit, rootState }) {
        if (
            window.localStorage.getItem('filters') &&
            window.localStorage.getItem('filterLocale') == rootState.locale.locale
        ) {
            commit('SET_FILTERS', JSON.parse(window.localStorage.getItem('filters')))
            return;
        }

        try {
            let response = await Api.get('/filters')
            window.localStorage.setItem('filters', JSON.stringify(response.data))
            commit('SET_FILTERS', response.data)
        } catch {
            commit('SET_FILTERS', [])
        } finally {
            window.localStorage.setItem('filterLocale', i18n.locale)
        }
    }
};


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
